var getProjCode = null;
var pointWktToCoordinates = null;

try {
  // Only provide component if react-openlayers is present in parent project
  var _require = require('@avinet/react-openlayers'),
      olUtils = _require.olUtils;

  getProjCode = function getProjCodeImpl(srid) {
    if (typeof srid === 'string' || srid instanceof String) {
      if (srid.indexOf('EPSG:') === 0) return srid;
      srid = parseInt(srid);
      if (isNaN(srid)) return null;
    }

    return srid ? 'EPSG:' + srid : null;
  };

  pointWktToCoordinates = function pointWktToCoordinatesImpl(wkt, sourceSrid, targetSrid) {
    try {
      if (!wkt) return null;
      var srid = 4326;
      var split = wkt.split(';');

      if (split.length > 1) {
        srid = parseInt(split[0].split('=')[1]);
        wkt = split[1];
      }

      if (sourceSrid) {
        srid = sourceSrid;
      }

      var feature = olUtils.createFeatureFromWkt(wkt);
      if (!feature) return null;
      var featureProjCode = getProjCode(srid);
      var projCode = getProjCode(targetSrid);
      var geom = feature.getGeometry();
      if (!geom) return null;

      if (featureProjCode !== projCode) {
        geom.transform(featureProjCode, projCode);
      }

      return geom.getCoordinates();
    } catch (ex) {
      return null;
    }
  };
} catch (ex) {}

export { getProjCode, pointWktToCoordinates };